module.exports = __webpack_public_path__ + "static/media/wordpress-ai.1bd30301.png";